export async function enableMocking() {
	const isDevelopment = process.env.NODE_ENV === 'development';
	const isBrowser = typeof window !== 'undefined' && typeof window.location !== 'undefined';

	// MSW має бути вимкнений за замовчуванням. Увімкнення тільки явним прапорцем:
	// `?mock=1` (перед hash‑роутером), або `localStorage.msw=1`, або `window.__MSW__=true`.
	const shouldEnable = (() => {
		if (!isDevelopment || !isBrowser) {
			return false;
		}

		const search = String(window.location.search || '');
		if (/(?:\\?|&)(mock|msw)=1(?:&|$)/.test(search)) {
			return true;
		}

		try {
			if (window.localStorage && window.localStorage.getItem('msw') === '1') {
				return true;
			}
		} catch (error) {
			// ignore storage access errors
		}

		return window.__MSW__ === true;
	})();

	if (!shouldEnable) {
		return;
	}

	const { worker } = await import('./browser');

	// `worker.start()` returns a Promise that resolves
	// once the Service Worker is up and ready to intercept requests.
	return worker.start({
		onUnhandledRequest: 'bypass',
	});
}
